import classnames from 'classnames'
import './AddButton.scss'

const AddButton = ({ add, remove, quantity = 0, addEnabled = true }) => {
  return (
    <div className="card-add">
      {quantity <= 0 ? (
        <button
          className={classnames('card-add__plus-button', {
            disabled: !addEnabled
          })}
          onClick={() => {
            addEnabled && add()
          }}>
          +
        </button>
      ) : (
        <div className="card-add__controls">
          <button className="card-add__controls-button" onClick={remove}>
            -
          </button>
          <span className="card-add__controls-qty">{quantity}</span>
          <button
            className={classnames('card-add__controls-button', {
              disabled: !addEnabled
            })}
            onClick={() => {
              addEnabled && add()
            }}>
            +
          </button>
        </div>
      )}
    </div>
  )
}

export { AddButton }
